<template>
    <Authenticated>
        <template #header>
            <PageTitle translationKey="kennisbank.title"/>
            <p v-if="$page.props.message !== null">{{ $__($page.props.message) }} </p>
        </template>

        <div v-html="options.introduction" v-if="options.introduction" class="pr-4 lg:pr-0 max-w-2xl color-regular pb-12 kennisbank--introduction" />
        <hr v-if="options.introduction" class="border-b-1 border-gray-200">

        <Tab
            v-if="$page.props.message === null"
            :subjects="subjectsData"
            :items="$page.props.data"
            :preselectedPostSlug="$page.props.preselected_post_slug"
            :preselectedSubjectSlug="$page.props.preselected_subject_slug"
            @setActiveSubject="setActiveSubject"
        />
    </Authenticated>
</template>

<script>
import PageTitle from "@/Components/PageTitle";
import Tab from "@/Components/Tab";
import Tabs from "@/Components/Tabs";
import Authenticated from '@/Layouts/Authenticated';

export default {
    data: () => ({
       subjectsData: {},
    }),
    props: {
        data: Object,
        options: Object,
        subjects: Object,
        message: String,
        preselected_post_slug: String,
        preselected_subject_slug: String,
    },
    components: {
        Authenticated,
        Tabs,
        PageTitle,
        Tab,
    },
    methods: {
        setActiveSubject(key) {
            Object
                .keys(this.subjectsData)
                .forEach(key => this.subjectsData[key].active = false);

            this.subjectsData[key].active = true;
        },
    },
    created() {
        this.subjectsData = this.$page.props.subjects;

        let loop = 0;
        Object.keys(this.subjectsData).forEach((key) => {
            this.subjectsData[key].active = loop === 0;
            loop++;
        });
    }
}
</script>
